/*
  order matters here
 */
export enum ShopifyAppRedirect {
  Integrations = 'integrations',
  Audiences = 'audiences',
  Onboarding = 'onboarding',
  Signup = 'signup',
}
